import { SyntheticEvent, useState } from 'react';

import { selectModalState } from '@lib/tools/modals/selector';
import { TModalTypes, actionModalClose, actionModalOpen, actionToggleModal } from '@lib/tools/modals/slice';
import { MODALS } from '@lib/tools/shared/helpers/consts';
import { useTypedDispatch, useTypedSelector } from '@lib/tools/views/hooks';

export const useModals = () => {
  const dispatch = useTypedDispatch();

  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  const openFeedbackModal = (e?: SyntheticEvent) => {
    e?.stopPropagation?.();
    setIsFeedbackModalOpen(true);
  };

  const closeFeedbackModal = () => setIsFeedbackModalOpen(false);

  const handleToggleModal = (modalName: TModalTypes) => dispatch(actionToggleModal({ modalName }));

  const isBasicServiceTermsModalOpened = useTypedSelector(selectModalState(MODALS.TERMS_OF_SERVICE_BASIC_MODAL));
  const isFoodPreferencesModalOpened = useTypedSelector(selectModalState(MODALS.FOOD_PREFERENCES_MODAL));
  const isManageModalOpened = useTypedSelector(selectModalState(MODALS.MANAGE_MODAL));
  const isDownloadAppModalOpened = useTypedSelector(selectModalState(MODALS.DOWNLOAD_APP_MODAL));
  const isThirdPartyConnectModalOpened = useTypedSelector(selectModalState(MODALS.THIRD_PARTY_CONNECT_MODAL));
  const isDiscoveryQuizModalOpened = useTypedSelector(selectModalState(MODALS.DISCOVERY_QUIZ_MODAL));

  const openModal = (modalName: TModalTypes) => dispatch(actionModalOpen({ modalName }));
  const closeAllModals = () => dispatch(actionModalClose());

  return {
    closeAllModals,
    closeFeedbackModal,
    handleToggleModal,
    isBasicServiceTermsModalOpened,
    isDiscoveryQuizModalOpened,
    isDownloadAppModalOpened,
    isFeedbackModalOpen,
    isFoodPreferencesModalOpened,
    isManageModalOpened,
    isThirdPartyConnectModalOpened,
    openFeedbackModal,
    openModal,
  };
};
